module.exports = __webpack_public_path__ + "img/illustration.c288f283.svg";